import type { FC } from 'react';
import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Flex, Grid } from '@atlaskit/primitives/compiled';

import { PlayPauseButton } from '../controls/PlayPauseButton';
import { PlaybackSpeedControl } from '../controls/PlaybackSpeedControl';
import { SkipForwardButton } from '../controls/SkipForwardButton';
import { SkipBackButton } from '../controls/SkipBackButton';
import { PlayFromBeginningButton } from '../controls/PlayFromBeginningButton';

const gridStyles = cssMap({
	root: {
		gridTemplateColumns: '1fr auto 1fr',
	},
});

export type MiniplayerControlsProps = {
	audioRef: React.RefObject<HTMLAudioElement>;
	isLoading: boolean;
	isPlaying: boolean;
};

export const MiniplayerControls: FC<MiniplayerControlsProps> = ({
	audioRef,
	isLoading,
	isPlaying,
}) => {
	return (
		<Grid testId="miniplayer-controls" xcss={gridStyles.root}>
			<Flex justifyContent="space-evenly" alignItems="center">
				<PlayFromBeginningButton audioRef={audioRef} isDisabled={isLoading} />
				<SkipBackButton audioRef={audioRef} isDisabled={isLoading} />
			</Flex>
			<PlayPauseButton audioRef={audioRef} isPlaying={isPlaying} isLoading={isLoading} />
			<Grid xcss={gridStyles.root}>
				<Flex justifyContent="center" alignItems="center">
					<SkipForwardButton audioRef={audioRef} isDisabled={isLoading} />
				</Flex>
				<Flex justifyContent="center" alignItems="center">
					<PlaybackSpeedControl />
				</Flex>
			</Grid>
		</Grid>
	);
};
